var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPhotoNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 5C13.7478 5 5 13.7478 5 24.5C5 35.2522 13.7478 44 24.5 44C35.2522 44 44 35.2522 44 24.5C44 13.7478 35.2522 5 24.5 5ZM24.6875 14C26.0225 14 27.3276 14.3959 28.4376 15.1376C29.5476 15.8793 30.4128 16.9335 30.9237 18.1669C31.4346 19.4003 31.5683 20.7575 31.3078 22.0669C31.0474 23.3762 30.4045 24.579 29.4605 25.523C28.5165 26.467 27.3137 27.1099 26.0044 27.3703C24.695 27.6308 23.3378 27.4971 22.1044 26.9862C20.871 26.4753 19.8168 25.6101 19.0751 24.5001C18.3334 23.3901 17.9375 22.085 17.9375 20.75C17.9375 18.9598 18.6487 17.2429 19.9145 15.977C21.1804 14.7112 22.8973 14 24.6875 14ZM24.5 41C22.2242 41.0009 19.9729 40.5299 17.8884 39.6165C15.8039 38.7032 13.9314 37.3675 12.3894 35.6937C13.2181 31.4019 20.6619 30.5 24.5 30.5C28.3381 30.5 35.7819 31.4019 36.6106 35.6928C35.0688 37.3669 33.1964 38.7029 31.1118 39.6164C29.0273 40.5299 26.7759 41.001 24.5 41Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 5,
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhotoNone);
export default __webpack_public_path__ + "static/media/user-photo-none.08a65c8f6c0f189d1c58af2911fcce32.svg";
export { ForwardRef as ReactComponent };